// extracted by mini-css-extract-plugin
export default {"saleBannerText":"Jrv1Dt"};